import request from '@/shared/api/request';

/**
 * Delete Snapshot.
 *
 * @param id { number } The ID of the Snapshot.
 */
export const deleteSnapshot = (id: number): Promise<void> =>
  request({
    url: `/snapshots/${id}`,
    method: 'DELETE',
  });
